const minimumIndexOfTitle = (text: string, position: number) => {
  const indexOfH2 = text.indexOf('<h2', position);
  const indexOfH3 = text.indexOf('<h3', position);
  if (indexOfH3 === -1 || (indexOfH2 > -1 && indexOfH2 < indexOfH3)) {
    return indexOfH2;
  }
  return indexOfH3;
};

const injectId = (
  content: string,
  lastIndex: number,
  counter: number,
): string => {
  const index = minimumIndexOfTitle(content, lastIndex) + 3;

  if (index < lastIndex) {
    return content;
  }
  const newContent = `${content.slice(
    0,
    index,
  )} id="blog_title_${counter}" ${content.slice(index)}`;
  return injectId(newContent, index + 1, counter + 1);
};

const useTitleInjection = (mainBlock: string) => injectId(mainBlock, 0, 0);

export default useTitleInjection;
